import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { checkHOD, checkHOU } from '../../permission-utils/settings';

const SurveyMenu = () => {
	const [isSupervisor, setIsSuperVisor] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	return (
		<>
			{isSupervisor && (
				<li>
					<Link to="/survey/overview">
						<div className="icon-w">
							<div className="os-icon os-icon-newspaper" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/survey">
					<div className="icon-w">
						<div className="os-icon os-icon-newspaper" />
					</div>
					<span>Dashboard</span>
				</Link>
			</li>

			<li>
				<Link to="/survey/kpi">
					<div className="icon-w">
						<div className="os-icon os-icon-newspaper" />
					</div>
					<span>KPI</span>
				</Link>
			</li>
		</>
	);
};

export default SurveyMenu;
